import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { translationChunksConfig } from '@spartacus/assets';
import { CmsConfig, ConfigModule, I18nModule, provideConfig } from '@spartacus/core';
import { IconModule, OutletPosition, provideOutlet } from '@spartacus/storefront';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FluDashboardBannerModule } from '../shared/modules/flu-dashboard-banner/flu-dashboard-banner.module';
import { NeedAssistanceModule } from '../shared/modules/need-assistance/need-assistance.module';
import { NeedToGoBackModule } from '../shared/modules/need-to-go-back/need-to-go-back.module';
import { ProductSearchModule } from '../shared/modules/product-search/product-search.module';
import { MessageDetailsComponent } from './message-details/message-details.component';
import { MessageHistoryComponent } from './message-history/message-history.component';

@NgModule({
  declarations: [MessageHistoryComponent, MessageDetailsComponent],
  imports: [
    CommonModule,
    I18nModule,
    IconModule,
    NgSelectModule,
    FormsModule,
    NgbModule,
    RouterModule,
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
    NeedToGoBackModule,
    FluDashboardBannerModule,
    ProductSearchModule,
    NeedAssistanceModule,
    ConfigModule.withConfig({
      cmsComponents: {
        MultiLocationSelectorComponent: {
          component: MessageHistoryComponent,
        },
        // MultiLocationSelectorComponent: {
        //   component: MessageHistoryComponent,
        // }
      },
    } as CmsConfig)
  ],
  providers: [
    provideOutlet({
      id: 'PlaceholderContentSlot',
      position: OutletPosition.REPLACE,
      component: MessageDetailsComponent,
    }),
    provideConfig({
      i18n: {
        backend: {
          loadPath: 'assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: translationChunksConfig,
      },
    }),
  ],
})
export class MessgeHistoryModule { }
